import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const TextColor = forwardRef<SVGSVGElement, IconProps>(({ color = 'currentColor', size = 16 }, forwardedRef) => {
  return (
    <svg width={size} height={size} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        opacity="0.98"
        d="M3.9792 13.9891L5.46742 10.0201H10.3045L11.8277 13.9891H13.1572L8.65647 2H7.34738L2.64966 13.9891H3.9792ZM5.96354 8.87288L7.96102 3.58203H8.04283L9.93246 8.87288H5.96354Z"
        fill={color}
      />
    </svg>
  )
})

export default TextColor
